import React from 'react';
import './LteQuoteItem.css';
import { isMobileView } from '../../../../Utility/utility'

const LteQuoteItem = (props) => {
  return(
    <div className='quote-item-container'>
      { 
        props.promotion ?
          isMobileView() ?
          <div className='quote-item-header quote-item-detail lte-quote-heading' automationid={`SalesLead_Div_ItemHeader_0`}>
            <div className="lte-quote-heading-wrapper">
              <span className="service-promotion-new" automationid="SalesLead_Div_AdditionalServicePromotion_0">{props.promotion}</span>
              <br/>
              <div className="lte-quote-price-wrapper">
                <span automationid={`SalesLead_P_QuoteItemName_0`}>{props.name}</span>
                <span automationid={`SalesLead_P_QuoteItemMonthlyCost_0`} className='quote-item-header-price'>{props.monthlyCost} x PM</span>
              </div>
            </div>
          </div>
          :
          <div className='quote-item-header quote-item-detail lte-quote-heading' automationid={`SalesLead_Div_ItemHeader_0`}>
            <span automationid={`SalesLead_P_QuoteItemName_0`}>{props.name}</span>
            <div>
              <span className="service-promotion-new" automationid="SalesLead_Div_AdditionalServicePromotion_0">{props.promotion}</span>
              <span automationid={`SalesLead_P_QuoteItemMonthlyCost_0`} className='quote-item-header-price'>{props.monthlyCost} x PM</span>
            </div>
          </div>
        :
        <div automationid={`SalesLead_P_QuoteItemMonthlyCost_0`} className='quote-item-header-price'>{props.monthlyCost} x PM</div>
      }

      <div className='quote-item-details'>
        <div className='quote-item-detail' automationid={`SalesLead_Div_QuoteItemDetails_0`}>
          <p automationid={`SalesLead_P_QuoteItemDataLabel_0`}>Data: </p>
          <p automationid={`SalesLead_P_QuoteItemDataValue_0`}>{props.data}</p>
        </div>
      </div>

      <div className="quote-lte-section">
        After the first month, you can stay connected on your preferred
        LTE plan. Once fibre is up and running, the LTE service will stop
        and you'll pay for the fibre line instead.
      </div>

      <div className='quote-item-footer'>
        <div className='footer-item' automationid={`SalesLead_Div_FooterItem_2`}>
          <p
            automationid={`SalesLead_P_MonthlyCostLabel_2`}
            className="quote-cost-label"
          >
            Total monthly cost for LTE :
          </p>
          <p
            automationid={`SalesLead_P_MonthlyCostValue_2`}
            className="quote-cost-price"
          >
            {props.monthlyCost} PM
          </p>
        </div>
      </div>
    </div>
  )
}

export default LteQuoteItem;